/* src/app/admin/user-role/create-or-update-user-role.component.scss */
.permissions-table {
  border-collapse: separate;
  border-spacing: 0;
}
.permissions-table th {
  background-color: #1b638b;
  color: #ffffff;
  padding: 5px;
}
.permissions-table th:first-child {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.permissions-table th:last-child {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.permissions-table td {
  padding-top: 5px;
  padding-bottom: 5px;
}
.permissions-table .text-left-align {
  text-align: left;
}
.permissions-table .text-center-align {
  text-align: center;
}
/*# sourceMappingURL=create-or-update-user-role.component-DPSETE6H.css.map */
